import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../common/controls/Input';
import Button from '../../../common/components/Button';
import { Wrapper, Title, ButtonsWrappers, Left } from './styled-components';
import { LabelError } from '../../../common/components/Labels';

const UpdatePasswordBox = ({
  onInputChange,
  onSubmit,
  credentials: { password, new_password, inlineError }
}) => (
  <Wrapper>
    <Title>Create New Password</Title>
    <Input
      type="password"
      name="password"
      required
      label="new password"
      value={password}
      placeholder="credentials"
      onChange={onInputChange}
    />
    <Input
      type="password"
      name="new_password"
      required
      label="Confirm Password"
      value={new_password}
      placeholder="credentials"
      onChange={onInputChange}
    />
    {inlineError && <LabelError> Passwords do not match </LabelError>}
    <ButtonsWrappers center="xs">
      <Left xs={8}>
        <Button name="login" label="Update" onClick={onSubmit} primary />
      </Left>
    </ButtonsWrappers>
  </Wrapper>
);

UpdatePasswordBox.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  credentials: PropTypes.shape({
    password: PropTypes.string,
    inlineError: PropTypes.bool,
    confirm_password: PropTypes.string
  }).isRequired
};

export default UpdatePasswordBox;



// WEBPACK FOOTER //
// ./src/views/officials-connect/components/NewPasswordBox/index.jsx